"use client";

import Image from "next/image";
import { useEffect, useState } from "react";

type CoreValue = {
  id: number;
  title: string;
  description: string;
  image: string;
};

export default function CoreValues() {
  const [values, setValues] = useState<CoreValue[]>([]);

  useEffect(() => {
    const fetchCoreValues = async () => {
      try {
        const res = await fetch(
          "https://portal.renvixx.com/api/core-values",
          {
            headers: { Accept: "application/json" },
            cache: "no-store",
          }
        );

        if (!res.ok) throw new Error("Failed to fetch core values");

        const json = await res.json();

        // 🔹 Latest first (Option 2)
        const ordered = [...(json.data || [])].sort(
          (a, b) => b.id - a.id
        );

        setValues(ordered);
      } catch (error) {
        console.error("Failed to fetch core values:", error);
      }
    };

    fetchCoreValues();
  }, []);

  if (!values.length) return null;

  return (
    <section className="bg-white">
      {/* Header */}
      <div className="bg-[#2a6380] text-center h-[300px] py-12 px-4">
        <p className="text-white text-sm uppercase tracking-widest mb-2">
          why choose us.
        </p>
        <h2 className="text-3xl sm:text-4xl font-semibold text-white">
          Our Core <span className="text-[#33c1c7] font-bold">Value</span>
        </h2>
      </div>

      {/* Cards */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 -mt-[200px]">
        {values.map((item) => (
          <div
            key={item.id}
            className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow p-6 flex flex-col items-center text-center"
          >
            <div className="relative w-40 h-40 mb-4">
              <Image
                src={item.image}
                alt={item.title}
                fill
                className="object-contain"
              />
            </div>

            <h3 className="text-xl font-semibold mb-3 text-gray-900">
              {item.title}
            </h3>

            {/* HTML description from API */}
            <div
              className="text-gray-600 text-sm leading-relaxed"
              dangerouslySetInnerHTML={{ __html: item.description }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
